// types
import { ConfigStates } from '@/theme/types/config';

// ==============================|| THEME CONSTANT ||============================== //

export const CSS_VAR_PREFIX = '';

// Post-login landing route (wired to the existing app routing).
export const APP_DEFAULT_PATH = '/common/project';

// Layout dimensions used by the Mantis dashboard layout.
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
export const HORIZONTAL_MAX_ITEM = 7;

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  MINI_VERTICAL = 'mini-vertical'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export const DEFAULT_THEME_MODE: ThemeMode = ThemeMode.SYSTEM;

// ==============================|| THEME CONFIG ||============================== //

const config: ConfigStates = {
  fontFamily: '\'Public Sans\', sans-serif',
  i18n: 'ro',
  menuOrientation: MenuOrientation.VERTICAL,
  container: true,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR
};

export default config;
